/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Free_DescriptionInputs */

const en_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard marketplace access`)
};

const es_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso estándar al mercado`)
};

const fr_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès standard à la marketplace`)
};

const de_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-Marktplatzzugang`)
};

const ja_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準のマーケットプレイスアクセス`)
};

const zh_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准的市场访问权限`)
};

const ar_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصول قياسي إلى السوق`)
};

const id_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses marketplace standar`)
};

const it_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso standard al marketplace`)
};

const ru_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартный доступ к маркетплейсу`)
};

const pt_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso padrão ao marketplace`)
};

const ko_tier_free_description = /** @type {(inputs: Tier_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표준 마켓플레이스 액세스`)
};

/**
* | output |
* | --- |
* | "Standard marketplace access" |
*
* @param {Tier_Free_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_free_description = /** @type {((inputs?: Tier_Free_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Free_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_free_description(inputs)
	if (locale === "es") return es_tier_free_description(inputs)
	if (locale === "fr") return fr_tier_free_description(inputs)
	if (locale === "de") return de_tier_free_description(inputs)
	if (locale === "ja") return ja_tier_free_description(inputs)
	if (locale === "zh") return zh_tier_free_description(inputs)
	if (locale === "ar") return ar_tier_free_description(inputs)
	if (locale === "id") return id_tier_free_description(inputs)
	if (locale === "it") return it_tier_free_description(inputs)
	if (locale === "ru") return ru_tier_free_description(inputs)
	if (locale === "pt") return pt_tier_free_description(inputs)
	return ko_tier_free_description(inputs)
});